/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RedshiftRestoreDestination } from '../models/RedshiftRestoreDestination';

export class RestoreRedshiftRequest {
  /**
  * Eon-assigned ID of the restore account where the Redshift resource will be restored.
  */
  'restoreAccountId': string;
  'destination': RedshiftRestoreDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "RedshiftRestoreDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreRedshiftRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

